import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	toDoToolTipsText: {
		id: 'software-backlog-panel.common.progress-bar.to-do-tool-tips-text',
		defaultMessage:
			'To Do: {count} of {total} ({total, plural, =0 {issue} one {issue} other {issues}})',
		description:
			'A tooltip for a progress bar that shows the number of issues with the "To do" status.',
	},
	inProgressToolTipsText: {
		id: 'software-backlog-panel.common.progress-bar.in-progress-tool-tips-text',
		defaultMessage:
			'In Progress: {count} of {total} ({total, plural, =0 {issue} one {issue} other {issues}})',
		description:
			'A tooltip for a progress bar that shows the number of issues with the "In progress" status.',
	},
	doneToolTipsText: {
		id: 'software-backlog-panel.common.progress-bar.done-tool-tips-text',
		defaultMessage:
			'Done: {count} of {total} ({total, plural, =0 {issue} one {issue} other {issues}})',
		description:
			'A tooltip for a progress bar that shows the number of issues with the "Done" status.',
	},
	doneToolTipsTextIssueTermRefresh: {
		id: 'software-backlog-panel.common.progress-bar.done-tool-tips-text-issue-term-refresh',
		defaultMessage:
			'Done: {count} of {total} ({total, plural, =0 {work items} one {work item} other {work items}})',
		description:
			'A tooltip for a progress bar that shows the number of issues with the "Done" status.',
	},
	inProgressToolTipsTextIssueTermRefresh: {
		id: 'software-backlog-panel.common.progress-bar.in-progress-tool-tips-text-issue-term-refresh',
		defaultMessage:
			'In Progress: {count} of {total} ({total, plural, =0 {work item} one {work item} other {work items}})',
		description:
			'A tooltip for a progress bar that shows the number of issues with the "In progress" status.',
	},
	toDoToolTipsTextIssueTermRefresh: {
		id: 'software-backlog-panel.common.progress-bar.to-do-tool-tips-text-issue-term-refresh',
		defaultMessage:
			'To Do: {count} of {total} ({total, plural, =0 {work item} one {work item} other {work items}})',
		description:
			'A tooltip for a progress bar that shows the number of issues with the "To do" status.',
	},
});
